import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (password.length < 6) { setErr("Password must be at least 6 characters."); return; }
    if (password !== confirm) { setErr("Passwords don't match."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Sign in.");
      nav("/login");
    } catch (e2) { setErr(formatApiError(e2.response?.data?.detail) || "Reset failed."); }
    finally { setLoading(false); }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-app max-w-md mx-auto px-6 pt-16">
        <div className="overline">Reset password</div>
        <h1 className="font-display text-4xl uppercase mt-3">Missing token.</h1>
        <p className="text-t2 mt-4 text-sm">The reset link is incomplete. Request a new one.</p>
        <Link to="/forgot-password" className="btn btn-outline w-full mt-6">Request a new link</Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-app max-w-md mx-auto px-6 pt-16">
      <div className="overline">Reset password</div>
      <h1 className="font-display text-4xl uppercase mt-3">New pass.</h1>
      <form className="mt-8 space-y-4" onSubmit={submit}>
        <input className="input" placeholder="New password" type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="reset-password" />
        <input className="input" placeholder="Confirm password" type="password" minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="reset-confirm" />
        {err && <div className="text-red text-sm" data-testid="reset-error">{err}</div>}
        <button className="btn btn-primary w-full" disabled={loading} data-testid="reset-submit">{loading ? "…" : "Update password"}</button>
      </form>
    </div>
  );
}
